module.exports = __webpack_public_path__ + "static/media/Camping.30ccd975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Camping.png
// module id = 1331
// module chunks = 3